export default "__VITE_ASSET__1bca5b46__"